



export const CourseCardSkelton = () => {
    return (
        <div
            className="course h-[30rem] relative overflow-hidden animate-pulse  group  bg-gray-400 flex rounded-3xl cursor-pointer hover:scale-105 transition-all duration-500" >
            <div  className='w-full h-auto object-cover aspect-square  group-hover:scale-[1.2] transition-all !duration-500' />
            <div className="absolute inset-0 bg-[rgba(0,0,0,0.2)]"></div>
            <div className="absolute  left-0 top-0 bg-gradient-to-b from-black via-transparent to-transparent"></div>
            <div className="absolute bottom-0 p-4 flex flex-col justify-start items-start ">
                <div
                    className=" text-white text-[30px] lg:text-[30px] group-hover:lg:text-[35px] 2xl:text-[40px] font-bold group-hover:2xl:text-[45px] h-5 rounded-full bg-gray-200/30 transition-all !duration-500 "></div>
            </div>
        </div >
    )
}


export const RowCardWithImageSkelton = () => {
    return (
        <div className="border-t border-dashed border-t-slate-400 md:p-2 py-3">
            <div

                className={`grid grid-cols-1 md:grid-cols-[20%_80%] h-[64] animate-pulse bg-gray-200/30  py-2 md:p-2 px-4 gap-3 rounded-lg md:w-96 2xl:w-[35rem]  items-stretch group`}>
                <div className='w-20 h-20 rounded-full bg-gray-200/30 px-3 pt-1 self-stretch'>
                </div>
                <div className='flex flex-col gap-2 p-4  w-full'>
                    <h1 className={`font-bold h-5 rounded-full  text-lg lg:text-lg  bg-gray-200/30 2xl:text-3xl `}></h1>
                    <p className={`w-full text-justify h-5 rounded-full bg-gray-200/30 md:text-left text-xs 2xl:w-11/12 lg:text-[10px] 2xl:text-sm mt-1 group-hover:!text-black`}></p>
                    <span className='p-2 px-3  h-5 w-12 rounded-sm bg-gray-200/30   font-bold text-xs '></span>
                </div>
            </div>
        </div>
    )
}

export const GraduatedCardSkelton = () => {
    return (
        <div className="w-60 2xl:w-96 h-[20rem] 2xl:h-[30rem]   bg-gray-200/30  relative border shrink-0 snap-center group select-none animate-pulse rounded-3xl overflow-hidden bg-cover bg-no-repeat bg-center">
            <div className="absolute bottom-0 w-full h-2/5 2xl:h-1/3 bg-gradient-to-b from-black/30 to-black/80 bg-opacity-10 p-4">
                <div className="flex flex-col justify-center h-full gap-5 ">
                    <h1 className="text-white  flex h-5 rounded-full bg-gray-200/30 w-full items-start capitalize text-justify font-bold text-sm 2xl:text-lg"></h1>
                    <p className="text-white  text-[9px]   rounded-full  capitalize w-full flex items-start flex-col"><span className="h-5 rounded-full w-full bg-gray-200/30"></span></p>
                </div>
            </div>

        </div>
    )
}
